import { useEffect, useState } from "react";
import StartOff from "../../assets/image/star-off.png";
import StartOn from "../../assets/image/star-on.png";
import HalfStart from "../../assets/image/half-start.png";
import { Image } from "@shopify/hydrogen";


export default function StarsFront({reviews, userCalification}) {
  const [calification, setCalification] = useState(userCalification ? userCalification : 0);
  const [decimal, setDecimal] = useState(0);
  const [numberCalification, setNumberCalification] = useState(0);
  const stars = [1,2,3,4,5];
  const [hiddeStars, setHiddeStars] = useState(false);

  const getDecimalPart = (number) => {
    return number % 1;
  }

  const defineData = (value) => {
    // (value > calification) ? StartOff : StartOn
    let floorCal = Math.floor(calification) + 1;

    if(value<floorCal){
      return StartOn; 
    }else if(floorCal === value && (decimal >= 0.25 && decimal <= 0.75)){
      return HalfStart;
    }else{ 
      return StartOff;
    }
  }

  useEffect(()=>{
    if(reviews){
      let average = 0;
      let totalReviews = 0;

      for(let review of reviews){
        if(review.calification){
          totalReviews++;
        }
        average += review.calification ? review.calification : 0;
      }

      setNumberCalification(totalReviews);

      average = (average>0) ? (average / totalReviews) : 0;
      setCalification(average);
      setDecimal(getDecimalPart(average));
    }else if(!calification){
      setHiddeStars(true);
    }
  },[]);

  return (
    <div class="stars-container" style={{visibility: hiddeStars ? 'hidden':''}}>
      {stars.map((value)=>{
          return(
            <Image
              src={ defineData(value) }
              width={20}
              height={20}
              alt=""
              className="star-image"
              key={value}
              style={{cursor:"initial"}}
            />
          )
        })}
        &nbsp;
        <span className="calification-total">{calification}</span>
        &nbsp; 
        {!userCalification && (
          <span className="calification-total-label">({numberCalification} Calificaciones)</span>
        )}
    </div>
  );
}